

import styles from 'css_modules/ItemsHeader.module.css';
import {ItemCell} from 'components/ItemCell';

export const ItemsHeader = ({editable,allItemsChecked,setAllItemsChecked,setCheckedItems}) => {
       
    const handleCheckbox = () => {
        if (!allItemsChecked===false){
            setCheckedItems([])
        }
        setAllItemsChecked(!allItemsChecked);
        
    }

    return (
        <>
        <div className={styles.rowwrapper}>

      
        <table className={styles.itemstable}>
        <tbody>
        <tr >
        <td className={styles.itemstd} style={{border:"1px solid var(--primary)",borderLeft:"none",borderTop:"none"}}>
        Č.
        </td>
        <td className={styles.polozka}style={{borderBottom:"1px solid var(--primary)",borderTop:"none"}}>
            <div className={styles.innerWrapper}>
                <div className={styles.nestedcell1}style={{borderRight:"1px solid var(--primary)",borderBottom:"none"}}>Kód</div>
                <div className={styles.nestedcell2}style={{borderRight:"1px solid var(--primary)"}}>Položka</div>
            </div>
        </td>
        <td className={styles.itemstd}style={{border:"1px solid var(--primary)",borderTop:"none",borderLeft:"none"}}>
        Množ.
        </td>
        <td className={styles.itemstd}style={{border:"1px solid var(--primary)",borderTop:"none",borderLeft:"none"}}>
        M.j.
        </td>
        <td className={styles.itemstd}style={{border:"1px solid var(--primary)",borderTop:"none",borderLeft:"none"}}>
        J. cena
        </td>
        <td className={styles.itemstd}style={{border:"1px solid var(--primary)",borderTop:"none",borderLeft:"none"}}>
        DPH</td>
        <td className={styles.itemstd}style={{border:"1px solid var(--primary)",borderTop:"none",borderLeft:"none"}}>
        Sleva %
        </td>
        <td className={styles.itemstd}style={{border:"1px solid var(--primary)",borderTop:"none",borderLeft:"none"}}>
        Částka
        </td>
        <td className={styles.itemstd}style={{borderBottom:"1px solid var(--primary)"}}>
        DPH
        </td>
        </tr>

        <tr>
            {editable===true ? 
            <td className={styles.checkcell}>
                 <ItemCell type="checkbox" name={"check"}   style={{ padding:'none',margin:'none', border: 'none', outline: 'none' }}
                 checked={allItemsChecked} disabled={!editable} onChange={handleCheckbox} />
            </td>        
                :
                <td className={styles.itemstd}></td>
            }
        
        <td className={styles.itemstd}style={{borderRight:"1px solid var(--primary)"}}>
        Poznámka
        </td>
        <td className={styles.itemstd}style={{borderRight:"1px solid var(--primary)"}}>
        Pár. sym
        </td>
        <td className={styles.itemstd}style={{borderRight:"1px solid var(--primary)"}}>
        Předkontace
        </td>
        <td className={styles.itemstd}style={{borderRight:"1px solid var(--primary)"}}>
        PDP
        </td>
        <td className={styles.itemstd}style={{borderRight:"1px solid var(--primary)"}}>
        Čl. DPH
        </td>
        <td className={styles.acrosstwocolumns}style={{borderRight:"1px solid var(--primary)"}}>
        Středisko
        </td>
        <td className={styles.itemstd}style={{borderRight:"1px solid var(--primary)"}}>
        Činnost
        </td>
        <td className={styles.itemstd}>
        Zakázka
        </td>
        </tr>
        </tbody>
        </table>
        
        </div>
        </>
    )
};